<label>As Of Date</label>
<input
    (click)="asOf.open()"
    [matDatepicker]="asOf"
    class="form-control date d-inline-block"
    color="accent"
    [(ngModel)]="filters.asOfDate"
    placeholder="Date"
/>
<mat-datepicker #asOf></mat-datepicker>
